export const MIN_PERSONALISATIONS_OPTIONS_FOR_EXPANDING = 2;
